(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-grid"] && !Shopify.designMode) return;
  try {
    
  class YGProductGrid extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.toggleButton = this.querySelector('[data-product-grid-toggle]');
      this.toggleLabel = this.querySelector('[data-product-grid-toggle-label]');

      if (!this.toggleButton || !this.toggleLabel) return;

      this.toggleButton.addEventListener('click', this.handleToggle);
    }

    disconnectedCallback() {
      if (!this.toggleButton) return;

      this.toggleButton.removeEventListener('click', this.handleToggle);
    }

    handleToggle() {
      const isOpen = this.hasAttribute('open');
      const nextOpen = !isOpen;
      const nextLabel = nextOpen
        ? this.toggleButton.getAttribute('data-less-label')
        : this.toggleButton.getAttribute('data-more-label');

      this.toggleAttribute('open', nextOpen);
      this.toggleButton.setAttribute('aria-expanded', String(nextOpen));
      this.toggleLabel.textContent = nextLabel;
    }
  }

  if (!window.customElements.get('yg-product-grid')) {
    window.customElements.define('yg-product-grid', YGProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab-banner"] && !Shopify.designMode) return;
  try {
    
  class YGTabBanner extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.handleClick = this.onClick.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      const initialIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.select(initialIndex < 0 ? 0 : initialIndex);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.initialized = false;
    }

    onClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      this.select(this.tabs.indexOf(tab));
    }

    onKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      const currentIndex = this.tabs.indexOf(tab);
      let nextIndex = currentIndex;
      const isRtl = getComputedStyle(this).direction === 'rtl';

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex + (isRtl ? -1 : 1);
      } else if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex + (isRtl ? 1 : -1);
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
      this.select(nextIndex, true);
    }

    onBlockSelect(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      this.select(this.tabs.indexOf(tab));
    }

    select(index, focus = false) {
      if (this.tabs.length === 0) return;

      const safeIndex = Math.min(Math.max(index, 0), this.tabs.length - 1);
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === safeIndex;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== safeIndex;
      });

      const activeTab = this.tabs[safeIndex];
      const activePanel = this.panels[safeIndex];

      if (focus) activeTab.focus();
      if (!activePanel) return;

      const imagesReady = this.preparePanelImages(activePanel);

      requestAnimationFrame(() => {
        this.updateSwiper(activePanel);

        imagesReady.then(() => {
          requestAnimationFrame(() => this.updateSwiper(activePanel));
        });
      });
    }

    preparePanelImages(panel) {
      const images = Array.from(panel.querySelectorAll('img'));

      images.forEach((image) => {
        if (image.loading === 'lazy') image.loading = 'eager';
      });

      return Promise.allSettled(
        images.map((image) => {
          if (image.complete && image.naturalWidth > 0) return Promise.resolve();
          return image.decode().catch(() => undefined);
        })
      );
    }

    updateSwiper(panel) {
      const swiperElement = panel.querySelector('yg-swiper');
      if (!swiperElement) return;

      if (swiperElement.swiper) {
        const swiper = swiperElement.swiper;
        swiper.update();

        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.updateSlidesClasses();
        }
        return;
      }

      customElements.whenDefined('yg-swiper').then(() => {
        requestAnimationFrame(() => {
          if (!swiperElement.swiper) return;

          const swiper = swiperElement.swiper;
          swiper.update();

          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.updateSlidesClasses();
          }
        });
      });
    }
  }

  if (!customElements.get('yg-tab-banner')) {
    customElements.define('yg-tab-banner', YGTabBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
